export default {
    about_title: "myUoM για κινητά",
    about_version: "Έκδοση V1.2.0",
    about_find_us_on_socials: "Βρείτε μας στα Social Media",
    about_project_members_title: "Τα μέλη της Ομάδας Ανάπτυξης"
}